import React from "react";

const UpdateSubject = ({ formData, handleChange, handleSubmit, error }) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Subject</h2>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Subject Name */}
        <div className="mb-4">
          <label className="block text-gray-700">Subject Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        {/* Subject Description */}
        <div className="mb-4">
          <label className="block text-gray-700">Subject Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="border w-full p-2"
          ></textarea>
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Update Subject
        </button>
      </form>
    </div>
  );
};

export default UpdateSubject;
